/**
 * @generated SignedSource<<d323995b76779da1f8c473b654641317>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_viewer$data = {
  readonly dealerDetailsReviewFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedDealerDetailsReviewContainerLazy_viewer" | "PdpSharedSellerTabsVariant_viewer">;
  readonly " $fragmentType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$key = {
  readonly " $data"?: PdpRespDealerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_viewer",
  "selections": [
    {
      "alias": "dealerDetailsReviewFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "dealerDetailsReview"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"dealerDetailsReview\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsReviewContainerLazy_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f78a98a985ce2446f375d099071e0ddc";

export default node;
